module.exports = __webpack_public_path__ + "img/browser_opera.92fee148.svg";